import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import * as IdKey from "short-uuid";
import { Button, Grid, Tooltip} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import { rejectUserPostulate } from "../../actions/postulates-actions";
import { getValidateCvByDocumentAndType } from "../../actions/cv-actions";
import { useStateValue } from "../../context/store";
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { DataContext } from "../../context/reducers/contextSearchUser";
import { permissionsConstans } from "../../constansPermissions";

const useStyles = makeStyles((theme) => ({
  MuiIconButtonEdgeEnd: {
    order: "-1",
  },
  root: {
    width: "100%",
    marginTop: "10px",
    marginLeft: "10px",
  },
  rootGrid: {
    flexGrow: 1,
  },
  heading: {
    fontSize: theme.typography.pxToRem(12),
    wordBreak: 'normal',
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
    wordBreak: 'normal'
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  iconEvent: {
    color: "#666666",
    cursor: "pointer",
    height: 18,
    width: 18,
  },
  details: {
    alignItems: "center",
    backgroundColor: "#EEFBFF",
  },
  column: {
    flexBasis: "39.6%",
    marginRight: 10,
  },
  columnEvent: {
    flexBasis: "33.33%",
    display: "flex",
    alignItems: "center"
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  buttonSearch: {
    color: "#ffffff",
    background: "#7EBDCE",
    width: 'max-content',
    marginRight: 10,
    position: 'relative',
    height: 'fit-content',
    "&:hover": { color: "white", background: "#099F9F" },
  },
  buttonReject: {
    color: "#ffffff",
    background: "#7EBDCE",
    width: 'max-content',
    marginRight: 3,
    marginLeft: 5,
    position: 'relative',
    height: 'fit-content',
    "&:hover": { color: "white", background: "#099F9F" },
  },
  donwloadHv: {
    textTransform: "toUpperCase",
    color: "#7EBDCE",
    background: "white",
    width: 'max-content',
    marginRight: 10,
    position: 'relative',
    border: "1px solid #7EBDCE",
    height: 'fit-content',
    "&:hover": { color: "white", background: "#099F9F" },
  },
  CloudDownloadOutlinedIcon: {
    marginRight: 7,
    fontSize: 25,
  },
}));

export default function TableUser(props) {
  const classes = useStyles();
  const id = IdKey.generate();
  const postulates = props?.data?.postulate?.statusPostulate;
  const [dataHv, setDataHv] = useState([]);
  const [{}, dispatch] = useStateValue();
  const {idVacancie} = useContext(DataContext);
  const curriculum = props?.data?.curriculum;
  const person = props?.data?.person;
  const postulate = props?.data?.postulate;
  const province = props?.data?.province;


  const getValueByKey = (object, header) => {
    if (header.child === null) {
      if(header.field === "levelEducation"){
        return props.data?.curriculum?.levelEducation;
      }
      if(header.field === "yearsExperience"){
        return props.data?.curriculum?.yearsExperience;
      }
      if(header.field === "provinceName"){
        return props.data?.town?.townName;
      }
      if(header.field === "postulationDate"){
        return moment(props.data?.postulate?.postulationDate).format('DD-MM-YYYY');
      }
      if(header.field === "statusDescriptionPostulate"){
        return props.data?.postulate?.statusDescriptionPostulate;
      }
      if (header.field) {
        let result = "";
        if (header.field.includes(",")) {
          header.field.split(/\s*,\s*/).forEach(function (myString) {
            result += object[myString] + " ";
          });
          return result;
        }
        return object[header.field];
      }
      return "";
    }
    return object[header.field] !== null
      ? object[header.field][header.child]
      : "";
  };

  const getValueByKeyUser = (object, header) => {
    if(header.field === "firstName"){
      return dataHv?.person?.firstName;
    }
    if(header.field === "secondName"){
      return dataHv?.person?.secondName;
    }
    if(header.field === "surname"){
      return dataHv?.person?.surname;
    }
    if(header.field === "secondSurname"){
      return dataHv?.person?.secondSurname;
    }
    if(header.field === "documentTypeName"){
      return dataHv?.person?.documentTypeName;
    }
    if(header.field === "documentNumber"){
      return dataHv?.person?.documentNumber;
    }
    if(header.field === "documentIssueDate"){
      let fecha = dataHv?.documentIssueDate;
      let creationDate = moment(fecha).format('DD/MM/YYYY');
      return creationDate;
    }
    if(header.field === "dateBirth"){
      if(dataHv?.person?.dateBirth){
        let fecha = dataHv?.person?.dateBirth;
        let creationDate = moment(fecha).format('DD/MM/YYYY');
        return creationDate;
      }else{
        return "";
      }
    }
    if(header.field === "domainGender"){
      return dataHv?.person?.domainGender.toLowerCase().split(" ").map(value => {return value.charAt(0).toUpperCase() + value.slice(1);});
    }
    if(header.field === "cellPhoneNumber"){
      return dataHv?.person?.cellPhoneNumber;
    }
    if(header.field === "phone"){
      return dataHv?.person?.phone;
    }
    if(header.field === "nameProvince"){
      return dataHv?.province?.name;
    }
    if(header.field === "nameTown"){
      return dataHv?.town?.name;
    }
    if(header.field === "externalEmail"){
      return dataHv?.person?.externalEmail;
    }
    if(header.field === "childrens"){
      return dataHv?.childrens?.length;
    }
    if(header.field === "occupation"){
      return dataHv?.profession?.occupation;
    }
    if (header.child === null) {
      if (header.field) {
        let result = "";
        if (header.field.includes(",")) {
          header.field.split(/\s*,\s*/).forEach(function (item) {
            result +=`${object[item] ?? '' } `;
          });
          return result;
        }
        return object[header.field];
      }
      return "";
    }
    return object[header.field] !== null
    ? object[header.field]
    : "";
  };

  const DonwloadHv = (props) => {
    return <a
    style={{ color: "#fff", paddingTop: "10px" }}
    href={`data:application/octet-stream;base64,${dataHv?.attachment?.cv}`}
    download={"cv.pdf"}
  >
    <Button
      onFocus={(event) => event.stopPropagation()}
      className={classes.donwloadHv}
    >
      <CloudDownloadIcon className={classes.CloudDownloadOutlinedIcon} />
      Hoja de vida
    </Button>
  </a>
  }

  const DonwloadPicture = (props) => {
    return <a
    style={{ color: "#fff", paddingTop: "10px" }}
    href={`data:application/octet-stream;base64,${dataHv?.attachment?.photo}`}
    download={
      dataHv?.attachment?.photoExtension
        ? "photo" +
          "." +
          dataHv?.attachment?.photoExtension
        : "photo.pdf"
    }
  >
    <Button
      onFocus={(event) => event.stopPropagation()}
      className={classes.donwloadHv}
    >
      <CloudDownloadIcon className={classes.CloudDownloadOutlinedIcon} />
      Foto
    </Button>
  </a>
  }

  const FlippedOrderExpansionPanelSummary = withStyles({
    root: {
      flexDirection: "row-reverse",
    },
  })(AccordionSummary);
  FlippedOrderExpansionPanelSummary.defaultProps = {
    IconButtonProps: { edge: "start" },
  };

  const handleClick = (data) => {
    const parameters = {
      statusPostulate: data?.postulate?.statusPostulate,
      personName: data?.person?.personName,
      chargeRequested: data?.chargeRequested,
      personDocument: data?.person?.personDocument,
      personDocumentType: data?.person?.personDocumentType,
      postulateId : data?.postulate?.postulateId

    }
  props.props.history
    .push(`${idVacancie}/start-process/${parameters?.personName}/${parameters?.statusPostulate}/${parameters?.chargeRequested}/${parameters?.personDocument}/${parameters?.personDocumentType}/${parameters?.postulateId}`)
  }

  const handleClickClose = () => props.setMessage({ open:false });

  const handleClickCloseAndGet = () =>{
    props.setMessage({...props.message, open:false });
  }

  const openModalConfirm = (data) => {
    props.setMessage({
      description: postulates !== "POSTULATE"
        ? `¿Está seguro que desea continuar proceso a ${data?.person?.personName}?`
        : `¿Está seguro que desea iniciar proceso a ${data?.person?.personName}?`,
      textButtonSubmit: "Aceptar",
      handleClick: () => handleClick(data),
      handleClickOut: () => handleClickClose(),
      type: "WARNING",
      open: true,
    });
  }

  const handleClickContract = (data) => {
    const documentEmploye = {
      document: data?.person?.personDocumentType,
      numberDocument: data?.person?.personDocument
    }
    props.props.history.push(`/dashboard/contract/generate-contract/${idVacancie}/${documentEmploye?.document}/${documentEmploye?.numberDocument}`)
  }

  const userResume = async () => {
    const userDocument = props.data?.person;
    const response = await getValidateCvByDocumentAndType(userDocument?.personDocument, userDocument?.personDocumentType, dispatch);
    setDataHv(response?.data);
  }

  useEffect(() => {
    userResume();
  }, [])

  const changeStateByReject = async (rejectUser) => {
    props.setMessage({...props.message, open:false});

    const response = await rejectUserPostulate(rejectUser);
    if(response &&(response?.status >= 200 && response?.status < 399)){
      props.setMessage({
        description: `Usuario rechazado a esta vacante`,
        textButtonSubmit: "Aceptar",
        handleClick: () => handleClickCloseAndGet(),
        oneButtons: true,
        type: "SUCCESS",
        open: true,
      });
    }else if(response?.status > 399 && response?.status !== 401 && response?.status !== 403 ){
      props.setMessage({
        description: response?.data?.detail
          ? response?.data?.detail
          : response?.data?.error,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    }else{
      props.setMessage({
        description: `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    }

    props.getReqs();
  }

  const rejectUser = (data) => {
    const rejectUser = {
      id: data?.postulate?.postulateId,
      status: "REJECTED"
    }
    props.setMessage({
      description: `¿Está seguro que desea rechazar el proceso de ${data?.person?.personName}?`,
      textButtonSubmit: "Aceptar",
      handleClick: () => changeStateByReject(rejectUser),
      handleClickOut: () => handleClickClose(),
      type: "WARNING",
      open: true,
    });
  }

  const permissionGenerateContract = () => {
    const isStatusPostulate = props.data?.postulate?.statusDescriptionPostulate.toLowerCase() === "seleccionado";
    const state = JSON.parse(localStorage.getItem("state"));
    const module = state?.permissions.find((x) => x.code ==='CON');
    if(module?.functionalities?.some((x)=> x === permissionsConstans.CON_CREAR) && isStatusPostulate){
      return  <Button
            style={{minWidth: "180px"}}
            onClick={()=> handleClickContract(props.data)}
            onFocus={(event) => event.stopPropagation()}
            className = {classes.buttonSearch}
          >
            Generar contrato
          </Button>
    }
  }

  return (
    <div className={classes.root}>
      <Accordion
        style={{borderLeftStyle: "solid", borderLeftColor: '#F8DF13'}}
      >
        <FlippedOrderExpansionPanelSummary
          aria-controls="panel1c-content"
          id={id}
          expandIcon={<ExpandMoreIcon />}
        >
          {props.headers.initialHeaders.map((header) => (
            <div className={classes.column}>
              <Typography className={classes.heading}>
                {header?.title}
              </Typography>
              <Typography className={classes.secondaryHeading}style={{flexBasis: 'auto', wordBreak: 'normal'}}>
                {person
                  ? getValueByKey(props?.data.person, header)
                  : curriculum
                      ? getValueByKey(props?.data.curriculum, header)
                      : postulate
                          ? getValueByKey(props?.data.postulate, header)
                          : province
                              ? getValueByKey(props?.data.province, header)
                              : getValueByKey(props?.data.town, header)
                }
              </Typography>
            </div>
          ))}
          <div className={classes.columnEvent}>
            <Tooltip title="Ver detalle" arrow placement="top">
              <VisibilityIcon className={classes.iconEvent} />
            </Tooltip>
            &nbsp;&nbsp;
            {
              postulates === "SELECTED" || postulates === "IN_PROCESS" || postulates === "PRESELECTED" || postulates === "POSTULATE"
              ? <Button
                  onClick={()=> rejectUser(props.data)}
                  onFocus={(event) => event.stopPropagation()}
                  className = {classes.buttonReject}
                >
                  Rechazar
                </Button>
              : null
            }
            &nbsp;&nbsp;
            {
              postulates === "POSTULATE"
              ? <Button
                  style={{minWidth: "180px"}}
                  onClick={()=> openModalConfirm(props.data)}
                  onFocus={(event) => event.stopPropagation()}
                  className = {classes.buttonSearch}
                  >
                  Iniciar proceso
                </Button>
              : null
            }
            {postulates === "SELECTED" ? permissionGenerateContract() : null}

            {
              postulates === "IN_PROCESS"
              ? <Button
                  style={{minWidth: "180px"}}
                  onClick={()=> openModalConfirm(props.data)}
                  onFocus={(event) => event.stopPropagation()}
                  className = {classes.buttonSearch}
                >
                  Continuar proceso
                </Button>
              : null
            }
          </div>
        </FlippedOrderExpansionPanelSummary>
        <AccordionDetails className={classes.details}>
          <div className={classes.rootGrid}>
            <Grid container spacing={3} style={{margin: '0px 20px'}}>
              {props.headers?.otherHeaders?.map((header) => (
                <Grid item xs={2}>
                  <Typography className={classes.heading}>
                    {header.title}
                  </Typography>
                  <Typography className={classes.secondaryHeading}>
                    {getValueByKeyUser(dataHv, header)}
                  </Typography>
                </Grid>
              ))}
              <DonwloadHv attachment={dataHv?.attachment?.cv}/>
              <DonwloadPicture attachment={dataHv?.attachment?.photo} />
            </Grid>
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
